<template>
    <section class="userSteps">
         <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-end mb-4">
               <!--  <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'add_funds',params:{'id':$route.params.id}}">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> Back
                </router-link> -->
                <div class="counterStep text-end" v-if="store.questionariesStatus?.status != 'SUBMITTED'">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('suitability.text1')}}<span class="bgTitle">{{$t('suitability.text2')}}</span></h3>
                </div>
            </div>
            <div class="col-12" v-if="getQuestionAnswer?.questions && getQuestionAnswer.questions.length > 0">
                <h4 class="mb-4">{{getQuestionAnswer.questions[Question_number].type}}</h4>
                <Form class="row personalDetails" @submit="submit"> 
                    <div class="col-12 col-md-9" v-for="ques,index in getQuestionAnswer.questions" :key="ques.id">
                        <h6 class="medium" v-show="parseInt(index) == parseInt(Question_number)">{{$t('question.text2')}} {{index+1}} {{$t('question.text3')}} {{getQuestionAnswer.questions.length}}</h6>
                        <p v-if="parseInt(index) == parseInt(Question_number)">{{ques.questions}}</p>
                        <ul class="radioColumn d-flex align-items-center flex-wrap mb-0" v-if="ques.experienceDeclarationAnswers && ques.experienceDeclarationAnswers.length > 0 && parseInt(index) == parseInt(Question_number)">
                            <li v-for="ans in ques.experienceDeclarationAnswers" :key="ans.id">
                                <label class="customCheckBox d-flex align-items-center radio mb-0" :class="[{'active' : Check(ques.id,ans.id)}]" @click="SetAnswer(ques,ans)">
                                    <span :class=" (Check(ques.id,ans.id)) ? 'active roundedCircle' : 'roundedCircle'"></span>
                                    <span class="name f-15">{{ans.answers}}</span>
                                </label>
                            </li>
                            <span class="text-danger" v-if="errorMsg">{{$t('suitability.text3')}}</span>
                        </ul>
                    </div>
                    <div class="d-flex align-items-center mt-4">
                        <a href="javascript:void(0)" class="grd_btn borderButton me-3" @click="prev()" v-if="Question_number != '0'"> {{$t('suitability.text4')}}</a>
                        <button type="submit" class="grd_btn" v-if="getQuestionAnswer.questions.length-1 == parseInt(Question_number)"> {{$t('suitability.text5')}}</button>
                        <a href="javascript:void(0)" class="grd_btn" v-else @click="next()">{{$t('suitability.text6')}}</a>
                    </div>
                </Form>
            </div>
        </div>
    </section>
</template>

<script>
 import { useMainStore } from "@/store";
 import { Form } from "vee-validate";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            answer_list : [],
            Question_number : 0,
            errorMsg : false

        }
    },
    computed : {
        getQuestionAnswer(){
            if(this.store.questionariesStatus?.status == 'SUBMITTED'){
               return this.store.questionariesStatus
            }else{
                if(this.store.stabilityQuestionsList.length){
                    let data =  this.store.stabilityQuestionsList.filter(i => parseInt(i.questionnaireId) != 1 && parseInt(i.questionnaireId) != 4);
                    if(data.length){
                        return data[0]
                    }else{
                        return []
                    }
                }else{
                    return []
                }
            }
        },
    },
    components : {
        Form
    },
    methods:{
        Check(question,answer){
            if(this.answer_list.length){
                let item = this.answer_list.find( i=> parseInt(i.question_id) == parseInt(question))
                if(item){
                    if(item.ans_id == answer){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        SetAnswer(ques,ans){
            if(ques,ans){
                let obj = {
                    "question_id": ques.id,
                    "ans_id": ans.id,
                    "points": ans.points,
                    "answer": ans.answers,
                    "type": ques.type
                }
                if(this.answer_list.length){
                    let index = this.answer_list.findIndex(i => parseInt(i.question_id) == parseInt(ques.id))
                    if(index > -1){
                        this.answer_list.splice(index,1,obj)
                    }else{
                        this.answer_list.push(obj)
                    }
                }else{
                    this.answer_list.push(obj)
                }
            }

        },
        next(){
            let question = this.getQuestionAnswer.questions[this.Question_number]
            if(Object.keys(question).length){
                let index = this.answer_list.findIndex(i => parseInt(i.question_id) == parseInt(question.id))
                if(index > -1){
                    this.Question_number += 1 
                    this.errorMsg = false
                }else{
                    this.errorMsg = true
                }
            }
        },
        prev(){
            this.Question_number -= 1 
        },
        getBrokerStabilityQuestionsList(){
            this.store.getBrokerStabilityQuestionsList({},true)
        }, 
        submit(){
            let key = (parseInt(this.Question_number) + 1).toString();
            if(key in this.answer_list){
                this.Question_number = key
            }else{
                this.callBrokerOuestionaries()
            }
        },
        callBrokerOuestionaries(){
            let requestData = {
                ques_ans_array : this.answer_list,
                type : 'suitability'
            }
            // let id = 0;
            // if(this.getQuestionAnswer.name == 'suitabilityeu'){
            //     id = 2
            // }else if(this.getQuestionAnswer.name == 'suitabilitygl'){
            //     id = 3
            // }else if(this.getQuestionAnswer.name == 'fxviewquestionnaire'){
            //     id = 1
            // }
            if(this.getQuestionAnswer.questionnaireId){
                this.store.saveBrokerOuestionaries(requestData,true,this.getQuestionAnswer.questionnaireId,this)
            }
        }
    },
    created(){
        if(this.store.questionariesStatus?.status != 'SUBMITTED'){
            this.getBrokerStabilityQuestionsList()
        }
    }
}
</script>